import { render, staticRenderFns } from "./ProductSingleTrendChart.vue?vue&type=template&id=289bebd0&scoped=true"
import script from "./ProductSingleTrendChart.vue?vue&type=script&lang=js"
export * from "./ProductSingleTrendChart.vue?vue&type=script&lang=js"
import style0 from "./ProductSingleTrendChart.vue?vue&type=style&index=0&id=289bebd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bebd0",
  null
  
)

export default component.exports